import React from "react";

/** Full-screen Semantic UI loader. */
function BotbuilderLoadingOverlay({ active }) {
  if (!active) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 100045,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        pointerEvents: "all",
      }}
      aria-busy="true"
      aria-live="polite"
    >
      <div
        className="ui loading form"
        style={{
          position: "relative",
          minHeight: "100px",
          minWidth: "200px",
          border: "none",
          boxShadow: "none",
          background: "transparent",
        }}
      />
    </div>
  );
}

export default BotbuilderLoadingOverlay;
